import React from "react";
import AuthService from "../services/authServise";
import { Row, Image } from "react-bootstrap";
import daplipro from "./../assets/dalipro-iot.png";
import flexicuiot from "./../assets/flexicuiot.jpeg";
import "./Info.css";
import { webConfig } from "../config";

function Info() {
  const authServise = new AuthService();
  if (!authServise.isAuthenticated()) {
    authServise.login();
  }

  let image = daplipro;
  let text =
    "DALIPro Remote Web Application for downloading / uploading configuration files.";

  if (webConfig.LEDVANCE === "true") {
    text =
      "FLEX CU IOT DALI-2 HCL TW Remote Web Application for downloading / uploading configuration files.";
    image = flexicuiot;
  }

  const docPrefix = webConfig.LEDVANCE === "true" ? "ledvance" : "inventronics";
  const thirdLevel = webConfig.LEDVANCE === "true" ? "flexcuiot" : "remote-access";

  return (
    <div className="h-100 w-100 p-5">
      <Row className="d-flex justify-content-center flex-column">
        <h3 className="text-center w-100">{text}</h3>
        <div className="text-center">
          <Image src={image} className="img-fluid" style={{ maxWidth: "574px" }}></Image>
        </div>

        <div class="policy">
          <a
            href={`https://${thirdLevel}.dalipro.io/docs/${docPrefix}_privacy.pdf`}
            target="_blank"
            rel="noreferrer"
          >
            Privacy policy
          </a>
          -
          <a
            href={`https://${thirdLevel}.dalipro.io/docs/${docPrefix}_tos.pdf`}
            target="_blank"
            rel="noreferrer"
          >
            Terms of use
          </a>
        </div>
      </Row>
    </div>
  );
}

export default Info;
